import React from "react";

import LogoContainer from "./Serving/LogoContainer";


import "../style/topBar.css";
import SidebarMenu from "./Serving/SidebarMenu";

export default function TopBar() {
    return (
        <>
            <div className="TopBar">
                <div className="leftAlignedItems">
                    <LogoContainer/>
                </div>
                <div className="rightAlignedItems">
                    <SidebarMenu/>
                </div>
            </div>
        </>
    );
}
